export default [
  {
    title: 'Developer',
    subtitle: 'Test account',
    price: 0,
    features: [
      {
        title: 'Secure storage',
        available: true
      },
      {
        title: '5 concurrent users',
        available: true
      },
      {
        title: 'Data analytics',
        available: true
      },
      {
        title: 'Full search access',
        available: false
      },
      {
        title: 'Automatic backups',
        available: false
      }
    ]
  },
  {
    title: 'Basic',
    subtitle: 'Freelancer',
    price: 10,
    features: [
      {
        title: 'Secure storage',
        available: true
      },
      {
        title: '5 concurrent users',
        available: true
      },
      {
        title: 'Data analytics',
        available: true
      },
      {
        title: 'Full search access',
        available: true
      },
      {
        title: 'Automatic backups',
        available: false
      }
    ]
  },
  {
    title: 'Managed',
    subtitle: 'Small business',
    price: 49,
    features: [
      {
        title: 'Secure storage',
        available: true
      },
      {
        title: '5 concurrent users',
        available: true
      },
      {
        title: 'Data analytics',
        available: true
      },
      {
        title: 'Full search access',
        available: true
      },
      {
        title: 'Automatic backups',
        available: true
      }
    ]
  },
  {
    title: 'Enterprise',
    subtitle: 'Corporate',
    price: 99,
    features: [
      {
        title: 'Secure storage',
        available: true
      },
      {
        title: '5 concurrent users',
        available: true
      },
      {
        title: 'Data analytics',
        available: true
      },
      {
        title: 'Full search access',
        available: true
      },
      {
        title: 'Automatic backups',
        available: true
      }
    ]
  }
];
